
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import ProductCategoryRepository from '@/repositories/webshop/ProductCategoryRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class ProductCategoryFormScreen extends Vue {
    @Inject()
    private readonly productCategoryRepository!: ProductCategoryRepository;
}
